import { css } from '@emotion/core';
import { MEDIA_BREAKPOINTS } from '../../../../common/services/breakpoints';

export const customerStatFilterMultiSelectCSS = ({ colors }) => css`
    border-radius: 0.5rem;
    cursor: pointer;
    svg {
        &:active {
            background-color: ${colors.neutral80};
            border-radius: 0.125rem;
            color: ${colors.neutral10};
        }
        &:hover {
            color: ${colors.neutral10};
        }
    }
    div {
        display: inline-block;
    }

    ${MEDIA_BREAKPOINTS.MEDIUM_LARGE_MAX} {
        width: 10.125rem;
    }
    ${MEDIA_BREAKPOINTS.EXTRA_LARGE} {
        width: 23.75rem;
    }
`;

export const customerStatFilterMultiSelectAllCustomersCSS = ({ colors }) => css`
    border-radius: 0.5rem;
    cursor: pointer;
    svg {
        &:active {
            background-color: ${colors.neutral80};
            border-radius: 0.125rem;
            color: ${colors.neutral10};
        }
        &:hover {
            color: ${colors.neutral10};
        }
    }
    div {
        display: inline-block;
    }

    ${MEDIA_BREAKPOINTS.MEDIUM_LARGE_MAX} {
        width: 7.125rem;
    }
    ${MEDIA_BREAKPOINTS.EXTRA_LARGE} {
        width: 20.75rem;
    }
`;

export const customerStatFilterTopDownMultiSelectCSS = css`
    border-radius: 0.5rem;
    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        width: 8rem;
    }
    ${MEDIA_BREAKPOINTS.MEDIUM} {
        width: 17.813rem;
    }
`;

export const customerStatFilterTopDownMultiSelectAllCustomersCSS = css`
    border-radius: 0.5rem;
    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        width: 7rem;
    }
    ${MEDIA_BREAKPOINTS.MEDIUM} {
        width: 14.813rem;
    }
`;

export const customerStatFilterMobileMultiSelectCSS = css`
    width: 10.75rem;
    border-radius: 0.5rem;
`;

export const customerStatFilterMobileMultiSelectAllCustomersCSS = css`
    width: 7.75rem;
    border-radius: 0.5rem;
`;

export const customerStatFilterSingleSelectCSS = css`
    cursor: pointer;
    div {
        ${MEDIA_BREAKPOINTS.MEDIUM_LARGE_MAX} {
            width: 10.125rem;
        }
        ${MEDIA_BREAKPOINTS.EXTRA_LARGE} {
            width: 23.75rem;
        }
    }
`;

export const customerStatFilterSingleSelectTopDownCSS = css`
    cursor: pointer;
    div {
        ${MEDIA_BREAKPOINTS.SMALL_MAX} {
            width: 8rem;
        }
        ${MEDIA_BREAKPOINTS.MEDIUM} {
            width: 17.813rem;
        }
    }
`;

export const customerStatFilterStatInputCSS = ({ colors, fontSizes }) => css`
    ${MEDIA_BREAKPOINTS.MEDIUM_LARGE_MAX} {
        width: 10.125rem;
    }
    ${MEDIA_BREAKPOINTS.EXTRA_LARGE} {
        width: 23.75rem;
    }
    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        width: 8rem;
    }
    ${MEDIA_BREAKPOINTS.MEDIUM} {
        width: 17.813rem;
    }
    width: 16.25rem;

    box-sizing: border-box;
    margin-bottom: 0.5rem;
    height: 2.25rem;
    border-radius: 0.5rem;
    font-size: ${fontSizes.small};
    background-color: ${colors.fieldRequiredYellow};
    border: 0.05rem solid ${colors.neutral60};
    outline: none;

    &:focus {
        border-color: ${colors.primaryBorderColorFocus};
    }
`;

export const customerStatFilterStatInputDisabledCSS = ({ colors, fontSizes }) => css`
    ${MEDIA_BREAKPOINTS.MEDIUM_LARGE_MAX} {
        width: 10.125rem;
    }
    ${MEDIA_BREAKPOINTS.EXTRA_LARGE} {
        width: 23.75rem;
    }
    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        width: 8rem;
    }
    ${MEDIA_BREAKPOINTS.MEDIUM} {
        width: 17.813rem;
    }
    width: 16.25rem;

    box-sizing: border-box;
    margin-bottom: 0.5rem;
    height: 2.25rem;
    border-radius: 0.5rem;
    font-size: ${fontSizes.small};
    border: 0.05rem solid ${colors.neutral60};
    outline: none;

    &:focus {
        border-color: ${colors.primaryBorderColorFocus};
    }
`;

export const customerStatFilterAdditionalInfoInputCSS = ({ colors, fontSizes }) => css`
    ${MEDIA_BREAKPOINTS.MEDIUM_LARGE_MAX} {
        width: 10.125rem;
    }
    ${MEDIA_BREAKPOINTS.EXTRA_LARGE} {
        width: 23.75rem;
    }
    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        width: 8rem;
    }
    ${MEDIA_BREAKPOINTS.MEDIUM} {
        width: 17.813rem;
    }
    width: 16.25rem;

    box-sizing: border-box;
    margin-bottom: 0.5rem;
    height: 2.25rem;
    padding: 0.75rem;
    border-radius: 0.5rem;
    font-size: ${fontSizes.small};
    background-color: ${colors.fieldRequiredYellow};
    border: 0.05rem solid ${colors.neutral60};
    outline: none;

    &:focus {
        border-color: ${colors.primaryBorderColorFocus};
    }
`;

export const filterSelectionStatInputContainerCSS = css`
    ${MEDIA_BREAKPOINTS.MEDIUM_LARGE_MAX} {
        width: 10.125rem;
    }

    ${MEDIA_BREAKPOINTS.EXTRA_LARGE} {
        width: 23.75rem;
    }

    ${MEDIA_BREAKPOINTS.SMALL_MAX} {
        width: 8rem;
    }

    ${MEDIA_BREAKPOINTS.MEDIUM} {
        width: 17.813rem;
    }

    width: 16.25rem;

    input {
        padding: 0.75rem;
    }

    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }
`;
